import useThemeStore from '@/Theme/store';
import {
  ArchiveBoxIcon,
  PhotoIcon,
  SpeakerWaveIcon,
  VideoCameraIcon,
} from '@heroicons/react/24/outline';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';

const WelcomeImage = () => {
  const { theme } = useThemeStore();
  const isDark = theme === 'dark';

  return (
    <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-12 my-4 md:my-8 px-4">
      {/* Left side - Gallery with chat.gif */}
      <NavLink to="/gallery" className="flex-1 max-w-2xl cursor-pointer">
        <div
          className={`relative ${
            isDark ? 'bg-[#323232]' : 'bg-[#FFFFFF]'
          } rounded-[17px] shadow-md overflow-hidden`}
        >
          {/* Header tabs */}
          <div
            className={`flex items-center justify-between gap-2 sm:gap-4 px-4 sm:px-6 py-3 sm:py-4 ${
              isDark ? 'bg-[#323232]' : 'bg-[#FFFFFF]'
            }`}
          >
            <div className="flex items-center gap-1 sm:gap-2 text-nue-blue font-bold text-sm sm:text-base">
              <ArchiveBoxIcon className="size-4 sm:size-5" />
              All
            </div>
            <div className="flex items-center font-bold gap-1 sm:gap-2 text-cool-gray text-sm sm:text-base">
              <PhotoIcon className="size-4 sm:size-5" />
              Image
            </div>
            <div className="flex items-center font-bold gap-1 sm:gap-2 text-cool-gray text-sm sm:text-base">
              <VideoCameraIcon className="size-4 sm:size-5" />
              Video
            </div>
            <div className="flex items-center font-bold gap-1 sm:gap-2 text-cool-gray text-sm sm:text-base">
              <SpeakerWaveIcon className="size-4 sm:size-5" />
              Audio
            </div>
          </div>

          {/* Main content area with chat.gif */}
          <div className="px-2 sm:px-4 pb-2 sm:pb-4">
            <div className="flex items-center justify-center">
              <img
                src="/gifs/chat.gif"
                alt="Interactive chat demonstration"
                className="w-full h-auto max-w-xs sm:max-w-[16rem] md:max-w-md rounded-lg"
              />
            </div>
          </div>
        </div>
      </NavLink>

      {/* Right side - Text content */}
      <div className="flex-1 max-w-lg text-center lg:text-left justify-center items-center">
        <h2
          className={`text-lg sm:text-xl lg:text-3xl font-bold ${
            isDark ? 'text-white' : 'text-gray-900'
          } mb-4 sm:mb-6 leading-tight`}
        >
          A Gallery of{' '}
          <span className="bg-gradient-to-r from-[#464BBA] to-[#EE6C4C] bg-clip-text text-transparent">
            Possibilities
          </span>
        </h2>

        <p
          className={`text-base sm:text-lg ${
            isDark ? 'text-gray-300' : 'text-gray-600'
          } mb-6 sm:mb-8 leading-relaxed`}
        >
          Access all your work in one place—and get inspired by what others are
          building.
        </p>

        <NavLink
          to="/gallery"
          className="inline-flex self-center justify-center items-center gap-2 bg-gradient-to-r from-[#464BBA] to-[#EE6C4C] text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-full font-bold hover:shadow-lg transition-all duration-300 group text-sm sm:text-base"
        >
          Explore the Gallery
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="group-hover:translate-x-1 transition-transform duration-300 sm:w-4 sm:h-4"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </NavLink>
      </div>
    </div>
  );
};

export default memo(WelcomeImage);
